import React, { useContext, useMemo, useState } from 'react'
import * as OC from '../data-comp'
import * as R from 'ramda'
import { Panel, Line, ExtraFieldLine, Line2, PanelAction } from 'views/order/v5/fragments/comp/panel'
import { Grid, Cell, Row, CellIndent } from 'views/order/v5/fragments/comp/grid'
import { UserConfigCtx, UserConfig, OrderDetailsSettings } from 'views/order/v5/comp-factory'
import { Order, OrderCtx } from 'views/order/v5/model-order'
import cx from 'classnames'
import moment from 'moment'

import {
  Form,
  FormGroup,
  FormText,
  Input,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  ButtonGroup,
  Button,
  Label,
} from 'reactstrap'
import { useOrderAdjustmentsAPI } from '../api/order-api'
import FeedbackInfo from '../feedback-info'
import { useFeedbackAPI } from '../api/feedback'
import Feedback2Info from '../feedback2-info'
import { useDriverAPI } from '../api/driver'
import { HItems } from '../edit-order/components/items'

export default function OrderDetails(props: { reloadOrder: () => void }) {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <Items />
          <FeedbackInfo />
          <Feedback2Info />
        </div>
        <div className="col-6">
          <OrderInfo reloadOrder={props.reloadOrder} />
          <OrderTotals />
        </div>
      </div>
    </>
  )
}

function Items(): JSX.Element {
  const order = useContext(OrderCtx) as Order
  const userConfig = useContext<UserConfig | null>(UserConfigCtx)
  const [userSettings, setUserSettings] = useState({})
  let actions: PanelAction[] = []
  const items = order.carts.items

  if (userConfig)
    actions = R.map(
      ([key, label]) => ({
        id: key,
        label: label,
        style: userConfig.getConfig(key) ? 'checked' : 'unchecked',
        onClick: () => {
          setUserSettings(R.assoc(key, userConfig.getConfig(key), userSettings))
          userConfig.setConfig(key, !userConfig.getConfig(key))
        },
      }),
      R.toPairs(OrderDetailsSettings)
    )
  return (
    <div className="row">
      <div className="col-12">
        <Panel id="order-items" label="Order Contents" actions={actions}>
          <Grid>
            <HItems items={items}>
              <Row separator={true}>
                <Cell>
                  <OC.Item.WithDeleted>
                    <OC.Item.Quantity /> <OC.Item.FullName />
                  </OC.Item.WithDeleted>
                </Cell>
                <Cell align="right">
                  <OC.Item.WithDeleted>
                    <OC.Data.Price />
                  </OC.Item.WithDeleted>
                </Cell>
                <Cell align="right">
                  <OC.Item.WithDeleted>
                    <OC.Item.TotalByQuantity />
                  </OC.Item.WithDeleted>
                </Cell>
              </Row>
              <OC.ItemComments>
                <Row>
                  <Cell>
                    <CellIndent level={1}>
                      {' '}
                      <OC.Item.WithDeleted>
                        <OC.Data.Comments />
                      </OC.Item.WithDeleted>
                    </CellIndent>
                  </Cell>
                </Row>
              </OC.ItemComments>
              <OC.Item.Modifiers>
                <Row>
                  <Cell>
                    <CellIndent level={1}>
                      <OC.Item.WithDeleted>
                        <OC.Data.Name />
                      </OC.Item.WithDeleted>
                      :
                    </CellIndent>
                  </Cell>
                  <Cell></Cell>
                  <Cell></Cell>
                </Row>
                <OC.Item.Options>
                  <Row>
                    <Cell>
                      <CellIndent level={2}>
                        <OC.Item.WithDeleted>
                          <OC.Item.Quantity /> <OC.Data.Name /><OC.ContextItemName />
                        </OC.Item.WithDeleted>
                      </CellIndent>
                    </Cell>
                    <Cell>
                      <OC.Item.WithDeleted>
                        <OC.Data.Price />
                      </OC.Item.WithDeleted>
                    </Cell>
                    <Cell></Cell>
                  </Row>
                </OC.Item.Options>
              </OC.Item.Modifiers>
            </HItems>
          </Grid>
        </Panel>
        <Panel id="order-updates" label="Order Updates">
          <Grid cols={2}>
            <OC.Adjustments.Iterate>
              <Row separator={true}>
                <Cell>
                  <OC.Adjustments.User.Name />{' '}
                  <span className="upd-email">
                    (<OC.Adjustments.User.Email />)
                  </span>
                </Cell>
                <Cell align="right">
                  <span className="upd-date">
                    <OC.Adjustments.CreatedAt />
                  </span>
                </Cell>
              </Row>
              <Row>
                <Cell span={2}>
                  <span className="badge upd-state">
                    <OC.Adjustments.State />
                  </span>{' '}
                  <span className="upd-comments">
                    <OC.Adjustments.Comments />
                  </span>
                </Cell>
              </Row>
              <OC.Adjustments.Actions.Iterate>
                <Row>
                  <Cell span={2}>
                    <span className="upd-action">
                      <OC.Adjustments.Actions.Description />
                    </span>
                  </Cell>
                </Row>
              </OC.Adjustments.Actions.Iterate>
              <Row>
                <Cell span={2} className="upd-totals">
                  <OC.Adjustments.Totals.Iterate>
                    <span className="badge badge-success">
                      <OC.Adjustments.Totals.Total />
                    </span>{' '}
                  </OC.Adjustments.Totals.Iterate>
                </Cell>
              </Row>
            </OC.Adjustments.Iterate>
          </Grid>
        </Panel>
      </div>
    </div>
  )
}

function TimeAdjustment(props: { onClose: () => void }): JSX.Element {
  const order = useContext(OrderCtx)
  const orderAdjustmentsAPI = useOrderAdjustmentsAPI()
  const [delay, setDelay] = useState<number>(0)
  const [isClosed, setClosed] = useState(false)

  const bsStyleForCustomDelay = (delay: number): string => {
    if (R.isEmpty(delay) || !delay) return 'secondary'
    else if (isNaN(delay)) return 'error'
    else if (delay < 0 || delay > 90) return 'error'
    else return 'success'
  }

  const onClose = () => {
    props.onClose()
  }
  const onSaveAndClose = (delay: number) => {
    if (order) {
      orderAdjustmentsAPI
        .updateTime(order.uuid, delay)
        .then(props.onClose)
        .catch((err) => {
          console.log('Error')
          alert('Failed to update order ASAP time. Please try again later')
        })
    }
  }

  const duration = (x: number) => {
    if (delay == x) {
      return (
        <Button key={x} color="secondary" onClick={() => setDelay(x)}>
          {x}
        </Button>
      )
    } else {
      return (
        <Button color="success" key={x} onClick={() => setDelay(x)}>
          {x}
        </Button>
      )
    }
  }

  const previewTime = (value: number) => {
    if (order) {
      const m = moment(Date.parse(order.carts.settings.time.value))
      const t = m.add(value, 'minutes')
      return moment(t).format('LLLZ')
    } else {
      return null
    }
  }

  const buttons = R.map(duration, [5, 10, 15, 20, 25, 30, 45, 60, 75, 90])

  return (
    <Modal isOpen={!isClosed} onClosed={() => setClosed(true)}>
      <ModalHeader>Adjust time | Add time</ModalHeader>
      <ModalBody>
        <div>
          Order is due: <span className="fa fa-time"></span>
          <OC.OrderTime />
        </div>
        <Form>
          <FormGroup>
            <Input plaintext className="col-xs-10 col-xs-offset-2">
              Please select how many minutes to add to the order time:
            </Input>
            <Label className="col-xs-2" style={{ fontWeight: 'bold' }}>
              Pick
            </Label>
            <br />
            <ButtonGroup>{buttons}</ButtonGroup>
            <FormText color="muted">Click a button to pick the order duration and save</FormText>
          </FormGroup>
        </Form>
        <div>
          Updated due time: <span className="fa fa-time"></span>
          {previewTime(delay)}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color={bsStyleForCustomDelay(delay)}
          className={cx({ hidden: bsStyleForCustomDelay(delay) != 'success' })}
          onClick={() => onSaveAndClose(delay)}>
          Save Duration & Close
        </Button>
        <Button color="danger" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

function OrderInfo(props: { reloadOrder: () => void }) {
  let actions: PanelAction[] = []
  const order = useContext(OrderCtx)
  const driver = useDriverAPI()
  if (order && order.carts.settings.time.id == 'ASAP') {
    actions = [
      ...actions,
      {
        id: 'set-time',
        label: 'Adjust Time',
        style: 'unchecked',
        onRender: (onClose) => (
          <TimeAdjustment
            onClose={() => {
              props.reloadOrder()
              onClose()
            }}
          />
        ),
      },
    ]
  }
  const formatDriverType = (type: string): string => {
    if (!type) return type
    return type
      .split('_')
      .map((part, i) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')
  }
  return (
    <div className="row">
      <div className="col-12">
        <Panel id="order-info" label="Order Info" actions={actions} actionsTitle="Update">
          <Line key="code" label="Code">
            <span className="fa fa-qrcode"></span> <OC.ConfCode />
          </Line>

          <Line key="service" label="Service">
            <OC.Service.Label />
            {driver && (
              <>
                {' — '}
                via {formatDriverType(driver.type)} by <>{driver.name}</>
                {driver.phone && (
                  <>
                    {' '}
                    (<a href={`tel:${driver.phone}`}>{driver.phone}</a>)
                  </>
                )}
                {driver.tracking_link && (
                  <>
                    {' '}
                    —{' '}
                    <a href={driver.tracking_link} target="_blank" rel="noopener noreferrer">
                      Track
                    </a>
                  </>
                )}
              </>
            )}
          </Line>
          <OC.Service.IsDelivery>
            <OC.Service.DeliveryAddress>
              <Line label="Address">
                <OC.Address.Full />
                <br />
                <em>
                  <OC.Address.Instructions />
                </em>
              </Line>
            </OC.Service.DeliveryAddress>
          </OC.Service.IsDelivery>
          <OC.Service.IsCurbside>
            <Line label="Car info">
              <OC.Service.CurbsideInfo />
            </Line>
          </OC.Service.IsCurbside>

          <Line key="due" label="Due">
            <span className="fa fa-time"></span>
            <OC.OrderTime />
          </Line>
          <OC.ExtraFields>
            <ExtraFieldLine />
          </OC.ExtraFields>
        </Panel>
      </div>
    </div>
  )
}

function OrderTotals(): React.JSX.Element {
  // ['subtotal', 'discount', 'delivery', 'service', 'tax', 'tip']
  const { totals } = useContext(OrderCtx)
  const convFeeCharge = totals.detailedCharges.find((c) => c.type == 'convenience_fee')
  const convFeeTotal = totals.detailedCharges.reduce(
    (acc, c) => (c.type === 'convenience_fee' ? acc + Number(c.amount) : acc),
    0
  )
  return (
    <div className="row">
      <div className="col-12">
        <Panel id="totals" label="Totals">
          <Grid>
            {totals.subtotal > 0 && (
              <Row>
                <Cell>Subtotal:</Cell>
                <Cell align="right">
                  <OC.Totals2.Subtotal />
                </Cell>
              </Row>
            )}
            {totals.discount > 0 && (
              <Row>
                <Cell>Discount:</Cell>
                <Cell align="right">
                  <OC.Totals2.Discount />
                </Cell>
              </Row>
            )}
            {totals.delivery > 0 && (
              <Row>
                <Cell>Delivery:</Cell>
                <Cell align="right">
                  <OC.Totals2.Delivery />
                </Cell>
              </Row>
            )}
            {totals.service > 0 && (
              <Row>
                <Cell>Service:</Cell>
                <Cell align="right">
                  <OC.Totals2.Service />
                </Cell>
              </Row>
            )}
            {totals.tax > 0 && (
              <Row>
                <Cell>Tax:</Cell>
                <Cell align="right">
                  <OC.Totals2.Tax />
                </Cell>
              </Row>
            )}
            {totals.tip > 0 && (
              <Row>
                <Cell>Tip:</Cell>
                <Cell align="right">
                  <OC.Totals2.Tip />
                </Cell>
              </Row>
            )}
            {totals.total > 0 && (
              <Row separator={true}>
                <Cell>
                  <strong>Order Total:</strong>
                </Cell>
                <Cell align="right">
                  <strong className="totals-grand">
                    <OC.Totals2.Total />
                  </strong>
                </Cell>
              </Row>
            )}
            {totals.hidden + totals.total_markup > 0 && (
              <Row>
                <Cell>{convFeeCharge ? convFeeCharge.label : 'Convenience Fee'}:</Cell>
                <Cell align="right">
                  <OC.Totals2.ConvenienceFee />
                </Cell>
              </Row>
            )}
          </Grid>
        </Panel>
      </div>
    </div>
  )
}
/** Old Version
function OrderTotals2(): React.JSX.Element {
  return (
    <div className="row">
      <div className="col-12">
        <Panel id="totals" label="Totals">
          <Grid>
            <OC.Totals.Iterate>
              <OC.Totals.IsntZero>
                <Row>
                  <Cell>
                    <OC.Totals.Label />:
                  </Cell>
                  <Cell align="right">
                    <OC.Totals.Value />
                  </Cell>
                </Row>
              </OC.Totals.IsntZero>
            </OC.Totals.Iterate>
            <Row>
              <Cell>
                <strong>Order Total:</strong>
              </Cell>
              <Cell align="right">
                <strong>
                  <OC.Totals.GrandTotal />
                </strong>
              </Cell>
            </Row>
            <Row>
              <Cell>Convenience Fee:</Cell>
              <Cell align="right">
                <OC.Totals.ConvenienceFee.Value />
              </Cell>
            </Row>
          </Grid>
        </Panel>
      </div>
    </div>
  )
}
*/
